/**
 * **CRITICAL:** Legacy `sharedStyles.key` map for older imports. Prefer named exports from
 * atomic modules; add keys here only when a consumer still uses the registry object.
 * @see atomicRules.ts
 */
import { StyleSheet, ViewStyle, TextStyle } from 'react-native';
import * as buttons from './buttons';
import * as cards from './cards';
import * as forms from './forms';
import * as layout from './layout';

/**
 * Registered styles — same keys as legacy `sharedStyles` usage. Import named atoms directly when possible:
 * `import { buttonRow, rootFill } from '../sharedStyles'`.
 * When adding keys, document `Used by:` above the export in the source atomic file.
 */
export const sharedStyles = StyleSheet.create({
  loaderContainer: layout.loaderViewport as ViewStyle,
  container: layout.rootFill as ViewStyle,
  centered: layout.flexCenter as ViewStyle,
  row: layout.row as ViewStyle,
  cardBase: cards.cardBase as ViewStyle,
  formSection: forms.formSection as ViewStyle,
  inputGroup: forms.inputGroup as ViewStyle,
  formFieldGap: forms.formFieldGap as ViewStyle,
  inputContainerFlush: forms.inputContainerFlush as ViewStyle,
  formFieldRow: forms.formFieldRow as ViewStyle,
  formFieldHalf: forms.formFieldHalf as ViewStyle,
  section: forms.sectionInset as ViewStyle,
  label: forms.formLabel as TextStyle,
  primaryButtonInner: buttons.primaryButtonInner as ViewStyle,
  primaryButtonText: buttons.primaryButtonText as TextStyle,
  outlineButtonInner: buttons.outlineButtonInner as ViewStyle,
  outlineButtonText: buttons.outlineButtonText as TextStyle,
  pageFooterBtnWrap: buttons.pageFooterBtnWrap as ViewStyle,
  pageFooterBtnInner: buttons.pageFooterBtnInner as ViewStyle,
  pageFooterBtnText: buttons.pageFooterBtnText as TextStyle,
  coloredFooterBtnInner: buttons.coloredFooterBtnInner as ViewStyle,
  coloredFooterBtnText: buttons.coloredFooterBtnText as TextStyle,
  buttonStack: buttons.buttonStack as ViewStyle,
  buttonWrap: buttons.buttonWrap as ViewStyle,
  button: buttons.button as ViewStyle,
  buttonFilled: buttons.buttonFilled as ViewStyle,
  buttonOutlined: buttons.buttonOutlined as ViewStyle,
  buttonText: buttons.buttonText as TextStyle,
  buttonTextOutline: buttons.buttonTextOutline as TextStyle,
  buttonRow: buttons.buttonRow as ViewStyle,
});
